import * as classNames from 'classnames'
import * as React from 'react'
import {Tabs as TabsUI} from 'wix-ui-tpa/Tabs'
import s from './tabs.st.css'

export const Tabs = props => <TabsUI {...props} className={classNames(s.root, {[s.mobile]: props.mobile})} />
